module.exports = __webpack_public_path__ + "static/media/jieqiabiaozhun63.03174c05.png";